import defaultState, { ChatReducer } from './defaultState'
import { chatTypes } from '../../actions/chat/chatTypes'
import { ReduxAction } from '../reducerType'

export default function (state: ChatReducer = defaultState, { type, payload }: ReduxAction): ChatReducer {

  switch (type) {

    case chatTypes.ADD_CHAT_NOTIFICATION:
      return { ...state, notifications: state.notifications + 1 }
    case chatTypes.SET_CHAT_NOTIFICATIONS:
      return { ...state, notifications: payload }
    case chatTypes.RESET_CHAT_NOTIFICATIONS:
      return { ...state, notifications: defaultState.notifications }
    default:
      return state

  }

}
